import {
    SESSION_STORAGE_KEY_PURCHASE_EVENT_POLICIES
} from "@falcon/services";

export function maybePushPurchaseEvent(policyReference: string): boolean {
    if (policyReference && !isPurchaseEventPushed(policyReference)) {
        // send purchase event to data layer if not already sent and if LvDataLayer is populated
        pushPurchaseEvent();
        return true;
    } else {
        return false;
    }
}

function pushPurchaseEvent(): void  {
    const key = 'adobeDataLayer';
    window[key] = window[key] || [];

    window[key].push({
        event: 'purchase',
        quoteInfo: removeNullValues(window.LvDataLayer || {})
    });

    const policyRefs = retrievePushedPolicyRefs();
    policyRefs.push(window.LvDataLayer.policyReference);
    const policyRefStr = JSON.stringify(policyRefs);
    window.sessionStorage.setItem(SESSION_STORAGE_KEY_PURCHASE_EVENT_POLICIES, policyRefStr);
}

function isPurchaseEventPushed(policyReference: string): boolean {
    const pushedPolicies = retrievePushedPolicyRefs();
    return pushedPolicies.includes(policyReference);
}

function retrievePushedPolicyRefs(): string[] {
    const pushedPoliciesStr = window.sessionStorage.getItem(SESSION_STORAGE_KEY_PURCHASE_EVENT_POLICIES);
    if (!pushedPoliciesStr) {
        return [];
    }
    return JSON.parse(pushedPoliciesStr);
}

function removeNullValues(obj: any): any {
    return Object.entries(obj).reduce((acc: Record<any, any>, [key, value]) => {
        if (value === null || value === undefined) {
            return acc;
        }
        if (Array.isArray(value)) {
            acc[key] = value.map(item =>
                item instanceof Object ? removeNullValues(item) : item
            ).filter(item => item !== null && item !== undefined);
        } else {
            acc[key] = value instanceof Object ? removeNullValues(value) : value;
        }
        return acc;
    }, Array.isArray(obj) ? [] : {});
}
